import Error from '../model/Error';
import SchoolYear from '../dto/SchoolYear';
import axios from 'axios';
import moment from 'moment';

export default class SchoolYearRepository {

    static create(name, start, end, immutableDate, kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .post('/school-years', {
                    name: name,
                    start: moment(start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    end: moment(end, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    kindergartenId: kindergartenId,
                    immutableDate: moment(immutableDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                } )
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(schoolYear) {
        return new Promise((resolve, reject) => {
            axios
                .put('/kindergarten/' + schoolYear.kindergartenId + '/school-years/' + schoolYear.id, {
                    id: schoolYear.id,
                    name: schoolYear.name,
                    start: moment(schoolYear.start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    end: moment(schoolYear.end, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    kindergartenId: schoolYear.kindergartenId,
                    immutableDate: moment(schoolYear.immutableDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                } )
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(schoolYearId) {
        return new Promise((resolve, reject) => {
            axios
                .delete('/school-years/' + schoolYearId)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findAll(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/kindergartens/' + kindergartenId + '/school-years')
                .then(response => resolve(response.data.data.map(data => SchoolYear.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
